module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"menuFilter":"Filter by menu","serviceFilter":"Filter by service","isActiveByDefault":"Filter by default recommendation","all":"All","yes":"Yes","no":"No"},"es":{"menuFilter":"Filtrar por menú","serviceFilter":"Filtrar por servicio","isActiveByDefault":"Filtrar por recomendación por defecto","all":"Todos","yes":"Si","no":"No"}}')
  delete Component.options._Ctor
}
